import { m } from 'framer-motion';
import { CloudinaryPicture } from '../CSCloudinaryAsset/Picture';
import styles from './style.module.scss';
import { CloudinaryImageFields } from '../CloudinaryImageWrapper';

/**
 * MediaItem component with framer-motion animations.
 *
 * Note: This component expects to be rendered within a MotionConfig provider
 * (e.g., ModularPageWrapper) to ensure animations respect user accessibility
 * preferences for reduced motion.
 */

export type MediaItemProps = {
  slideIndex: number;
  activeSlideIndex: number;
  initialAnimate: boolean;
  media?: {
    mobile: CloudinaryImageFields;
    desktop: CloudinaryImageFields;
  };
};
export const MediaItem = ({
  media,
  slideIndex,
  activeSlideIndex,
  initialAnimate
}: MediaItemProps) => {
  if (media === undefined) {
    return null;
  }
  const getAnimation = (currentSlideIndex: number) => {
    const isCurrentActive = activeSlideIndex === currentSlideIndex;
    const isNextActive = activeSlideIndex === currentSlideIndex + 1;
    if (isCurrentActive || isNextActive) {
      return {
        opacity: 1,
        scale: 1.05,
        zIndex: 1
      };
    }
    return {
      opacity: 0,
      scale: 1,
      zIndex: 0
    };
  };
  return <m.div initial={initialAnimate ? {
    opacity: 0,
    scale: 1,
    zIndex: 0
  } : false} animate={getAnimation(slideIndex)} transition={{
    duration: 0.5,
    ease: 'easeInOut'
  }} className={styles.mediaItem} aria-hidden={activeSlideIndex !== slideIndex}>
      <CloudinaryPicture alt={media.desktop.alt ?? ''} sources={[{
      minWidth: 0,
      cloudinaryAsset: media.mobile.cloudinaryAsset
    }, {
      minWidth: 560,
      cloudinaryAsset: media.desktop.cloudinaryAsset
    }]} imageProps={{
      fetchPriority: 'high'
    }} />
    </m.div>;
};